import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { 
  Users, 
  MapPin, 
  Globe, 
  Award, 
  Heart, 
  BookOpen,
  Building2,
  Shield,
  Star
} from 'lucide-react';


import PartnerCardImg from '../Assests/partnersimg.png'
import SablaImg from '../Assests/Sabla.jpg';
import GraminVikashImg  from '../Assests/gramin_vikas_sansthan.jpeg'
import MamtaLogoImg  from '../Assests/Mamta-logo.png'
import FlexcLogoImg  from '../Assests/FlexC_logo.png'
import DharaLogoImg  from '../Assests/dharalogo.png'
import WaftLogoImg  from '../Assests/waftlogo.png'
import SRSLogoImg  from '../Assests/SRS.png'
import RoomToReadyLogoImg  from '../Assests/room_to_read.svg'
import ProntoLogoImg  from '../Assests/logo_pronto.png'

import TriLogoImg  from '../Assests/TRI-logo.png'

import MahilaLogoImg  from '../Assests/Mahila_kala.webp'
import CentralDirectLogoImg  from '../Assests/central_direct.png'
import JeevanBikasLogoImg  from '../Assests/jeevan_bikas_samaj.png'
import HansLogoImg  from '../Assests/hans_foundation.svg'
import AIFLogoImg  from '../Assests/AIF-logo.png'


import HeiferLogoImg  from '../Assests/heifer_fnternational.svg'

import PariwarLogoImg  from '../Assests/pariwar_logo.png'





const Partners = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');

  const partnersData = [
    { 
      name: 'Room To Read', 
      place: 'Global', 
      category: 'Education',
      description: 'Transforming lives through literacy and education',
      image: RoomToReadyLogoImg,
      type: 'International NGO'
    },
    { 
      name: 'Hans Foundation', 
      place: 'India', 
      category: 'Health',
      description: 'Healthcare and social development initiatives',
      image: HansLogoImg,
      type: 'Foundation'
    },
    { 
      name: 'Pronto International', 
      place: 'Global', 
      category: 'Development',
      description: 'International development and humanitarian aid',
      image: ProntoLogoImg,
      type: 'International NGO'
    },
    { 
      name: 'Heifer International', 
      place: 'Global', 
      category: 'Rural Development',
      description: 'Ending hunger and poverty through sustainable agriculture',
      image: HeiferLogoImg,
      type: 'International NGO'
    },
    { 
      name: 'MAMTA-Health Institute for Mother and Child', 
      place: 'India', 
      category: 'Health',
      description: 'Maternal and child health research and implementation',
      image: MamtaLogoImg,
      type: 'Research Institute'
    },
    { 
      name: 'Flexc', 
      place: 'India', 
      category: 'Technology',
      description: 'Technology solutions for social impact',
      image: FlexcLogoImg,
      type: 'Tech Company'
    },
    { 
      name: 'Transforming Rural India Foundation', 
      place: 'India', 
      category: 'Rural Development',
      description: 'Comprehensive rural transformation programs',
      image: TriLogoImg,
      type: 'Foundation'
    },
    { 
      name: 'WAFT Education Trust', 
      place: 'India', 
      category: 'Education',
      description: 'Educational initiatives and skill development',
      image: WaftLogoImg,
      type: 'Trust'
    },
    { 
      name: 'Mahila Kala Kendra Bhojpur', 
      place: 'Bihar, India', 
      category: 'Women Empowerment',
      description: 'Women\'s art and cultural center',
      image: MahilaLogoImg,
      type: 'Cultural Center'
    },
    { 
      name: 'Dhara Sansthan', 
      place: 'Rajasthan, India', 
      category: 'Rural Development',
      description: 'Community development and livelihood programs',
      image: DharaLogoImg,
      type: 'NGO'
    },
    { 
      name: 'Centre Direct', 
      place: 'India', 
      category: 'Development',
      description: 'Direct community development interventions',
      image: CentralDirectLogoImg,
      type: 'NGO'
    },
    { 
      name: 'Jeevan Bikas Samaj', 
      place: 'Birat Nagar, Nepal', 
      category: 'Social Development',
      description: 'Social development and community welfare',
      image: JeevanBikasLogoImg,
      type: 'Social Organization'
    },
    { 
      name: 'Pariwar Kalyan Avm Jan Sewa Sansthan', 
      place: 'Raebareli, Uttar Pradesh', 
      category: 'Social Welfare',
      description: 'Family welfare and public service initiatives',
      image: PariwarLogoImg,
      type: 'Social Organization'
    },
    { 
      name: 'Gramin Vikas Sansthan', 
      place: 'Raebareli, Uttar Pradesh', 
      category: 'Rural Development',
      description: 'Rural development and village transformation',
      image: GraminVikashImg,
      type: 'NGO'
    },
    { 
      name: 'Student Relief Societies', 
      place: 'Jaipur, Rajasthan', 
      category: 'Education',
      description: 'Student welfare and educational support',
      image: SRSLogoImg,
      type: 'Educational Society'
    },
    { 
      name: 'SABLA', 
      place: 'Lucknow, Uttar Pradesh', 
      category: 'Women Empowerment',
      description: 'Adolescent girls empowerment and development',
      image: SablaImg,
      type: 'Government Program'
    },
    { 
      name: 'American India Foundation', 
      place: 'Dehradun, Uttarakhand', 
      category: 'Development',
      description: 'Multi-sectoral development alliance',
      image: AIFLogoImg,
      type: 'AIF'
    }
  ];

  const categories = ['All', 'Education', 'Health', 'Rural Development', 'Women Empowerment', 'Social Welfare', 'Technology', 'Development'];

  const filteredPartners = partnersData.filter(partner => 
    selectedCategory === 'All' || partner.category === selectedCategory
  );

  const getCategoryIcon = (category) => {
    switch (category) {
      case 'Education': return <BookOpen className="h-5 w-5" />;
      case 'Health': return <Heart className="h-5 w-5" />;
      case 'Rural Development': return <Building2 className="h-5 w-5" />;
      case 'Women Empowerment': return <Users className="h-5 w-5" />;
      case 'Social Welfare': return <Shield className="h-5 w-5" />;
      case 'Technology': return <Globe className="h-5 w-5" />;
      case 'Development': return <Award className="h-5 w-5" />;
      default: return <Star className="h-5 w-5" />;
    }
  };

  const getCategoryColor = (category) => {
    switch (category) {
      case 'Education': return 'from-blue-500 to-blue-600';
      case 'Health': return 'from-red-500 to-red-600';
      case 'Rural Development': return 'from-green-500 to-green-600';
      case 'Women Empowerment': return 'from-pink-500 to-pink-600';
      case 'Social Welfare': return 'from-purple-500 to-purple-600';
      case 'Technology': return 'from-indigo-500 to-indigo-600';
      case 'Development': return 'from-orange-500 to-orange-600';
      default: return 'from-gray-500 to-gray-600';
    }
  };

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 via-white to-blue-50 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 left-10 w-32 h-32 border-2 border-primary-300 rounded-full"></div>
        <div className="absolute top-40 right-20 w-24 h-24 border-2 border-accent-300 transform rotate-45"></div>
        <div className="absolute bottom-32 left-1/4 w-20 h-20 border-2 border-primary-400 rounded-full"></div>
        <div className="absolute bottom-20 right-1/3 w-16 h-16 border-2 border-accent-400 transform rotate-12"></div>
      </div>

      <div className="container-custom px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Header Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <div className="inline-flex items-center px-4 py-2 bg-primary-100 text-primary-700 rounded-full text-sm font-semibold mb-6">
            <Users className="h-4 w-4 mr-2" />
            Our Trusted Partners
          </div>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
            Partners in <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-600 to-accent-600">Impact</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Collaborating with leading organizations worldwide to create meaningful change and drive sustainable development across communities.
          </p>
        </motion.div>

        {/* Category Filter */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
          className="flex flex-wrap justify-center gap-3 mb-12"
        >
          {categories.map((category) => (
            <motion.button
              key={category}
              onClick={() => setSelectedCategory(category)}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 ${
                selectedCategory === category
                  ? 'bg-gradient-to-r from-primary-600 to-accent-600 text-white shadow-lg'
                  : 'bg-white text-gray-700 border border-gray-200 hover:border-primary-300 hover:text-primary-600'
              }`}
            >

              {category}
            </motion.button>
          ))}
        </motion.div>

        {/* Partners Grid */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8"
        >
          {filteredPartners.map((partner, index) => (
            <motion.div
              key={partner.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -5 }}
              className="group"
            >
              <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 h-full flex flex-col">
                {/* Partner Logo/Image */}
                <div className="flex justify-center mb-4">
                  <div className="relative">
                    <div className="w-30 h-30 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                      <img
                        src={partner.image}
                        alt={partner.name}
                        className="w-20 h-20 rounded-xl object-contain"
                      />
                    </div>
                    {/* <div className={`absolute -top-2 -right-2 w-8 h-8 rounded-full bg-gradient-to-r ${getCategoryColor(partner.category)} flex items-center justify-center text-white shadow-lg`}>
                      {getCategoryIcon(partner.category)}
                    </div> */}
                  </div>
                </div>

                {/* Partner Info */}
                <div className="text-center flex-1">
                  <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-primary-600 transition-colors">
                    {partner.name}
                  </h3>
                  <div className="flex items-center justify-center text-gray-500 mb-2">
                    <MapPin className="h-4 w-4 mr-1" />
                    <span className="text-sm">{partner.place}</span>
                  </div>
                  <span className="inline-block bg-gray-100 text-gray-600 px-3 py-1 rounded-full text-xs font-medium mb-3">
                    {partner.type}
                  </span>
                  <p className="text-gray-600 text-sm leading-relaxed line-clamp-3">
                    {partner.description}
                  </p>
                </div>

                {/* Category Badge */}
                <div className="mt-4 pt-4 border-t border-gray-100">
                  <div className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-gradient-to-r ${getCategoryColor(partner.category)} text-white`}>
                    {getCategoryIcon(partner.category)}
                    <span className="ml-1">{partner.category}</span>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>

        {/* Stats Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          viewport={{ once: true }}
          className="mt-20 bg-gradient-to-r from-primary-600 to-accent-600 rounded-2xl p-8 text-white"
        >
          <div className="text-center mb-8">
            <h3 className="text-3xl font-bold mb-2">Partnership Impact</h3>
            <p className="text-primary-100">Together, we're making a difference</p>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {[
              { value: "17+", label: "Active Partners", icon: <Users className="h-8 w-8" /> },
              { value: "200+", label: "Projects Completed", icon: <Award className="h-8 w-8" /> },
              { value: "2+", label: "Countries", icon: <Globe className="h-8 w-8" /> },
              { value: "100K+", label: "Lives Impacted", icon: <Heart className="h-8 w-8" /> }
            ].map((stat, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-3">
                  {stat.icon}
                </div>
                <div className="text-3xl font-bold mb-1">{stat.value}</div>
                <div className="text-primary-100 text-sm">{stat.label}</div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Partners;
